import {BASE_URL} from "../../config/network";
import {resolveWhiteLabelSubsidiaryId} from "../../config/subsidiaryId";

const searchUserAPI = async ({subsidiaryId, email, mobilePhoneNumber = ""}) => {
    const requestSubsidiaryId = resolveWhiteLabelSubsidiaryId(subsidiaryId);

    const URL = `${BASE_URL}/${requestSubsidiaryId}/public/client/search-user`
    const METHOD = "POST"
    const HEADERS = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }

    const payload = {
        email_address: email
    }

    if (mobilePhoneNumber) {
        payload.mobile_phone_number = mobilePhoneNumber
    }

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS,
        body: JSON.stringify(payload)
    })

    if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`)
    }

    return await response.json()
}

export {searchUserAPI}
